import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { OAuthService } from 'angular-oauth2-oidc';
import { HomePage } from '../models/homePage';
import { RoutePath } from '../models/routePath';
import { SubscriptionFilters } from '../../features/subscription/models/subscription-filters.model';
import { SubscriptionResponse } from '../../features/subscription/models/subscription-response.model';
import { Pagination } from '../../features/subscription/models/pagination.model';
import { Sorting } from '../../features/subscription/models/sorting.model';
import { UrlFormatterService } from '../../features/subscription/services/urlFormatter.service';
import { SubscriptionHttpService } from '../../features/subscription/services/subscriptionHttp.service';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomePagePreferenceGuard  {
  constructor(private router: Router, private oAuthService: OAuthService, private subscriptionHttpService: SubscriptionHttpService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const claims: any = this.oAuthService.getIdentityClaims();
    if (claims) {
      if (claims.home_page) {
        const homePageUserPreferences: string = claims.home_page;
        Object.values(HomePage).forEach((value, index) => {
          if (value === homePageUserPreferences) {
            const enumName = Object.keys(HomePage)[index];
            this.handleRedirection(enumName);
          }
        });

        return of(false);
      } else if (claims.user_type === 'ADM_LOC' && (claims.groups.includes('GestionAbonnements') || claims.groups.includes('ConsultationAbonnements'))) {
        // Si l'utilisateur est un admin local et que son organisation n'a pas d'abonnement actif
        // alors redirection par défaut sur la page de gestion des abonnements : https://gitlab.hubee.numerique.gouv.fr/hubee/suivi-projet/-/issues/140
        let totalActiveSubscriptions: number = 0;

        return this.getOrganizationActiveSubscriptionsAndRedirectIfNeeded().pipe(
          map(subscriptionResponse => {
            if (subscriptionResponse) {
              totalActiveSubscriptions = subscriptionResponse.totalSubscriptions;
              if (totalActiveSubscriptions === 0) {
                this.router.navigate(['/subscriptions']);
              } else {
                this.router.navigate(['/subfolders'], {
                  queryParams: {
                    status: 0,
                  },
                });
              }

              return false;
            } else {
              this.router.navigate(['/subfolders'], {
                queryParams: {
                  status: 0,
                },
              });
              return false;
            }
          }));
      } else {
        this.router.navigate(['/subfolders'], {
          queryParams: {
            status: 0,
          },
        });

        return of(false);
      }
    } else {
      this.router.navigate(['/subfolders'], {
        queryParams: {
          status: 0,
        },
      });

      return of(false);
    }
  }

  private handleRedirection(enumName: string): void {
    const navigationString = String(RoutePath[enumName]).split('?');
    if (navigationString[0] === '/subfolders') {
      const status = navigationString[1].split('=');
      this.router.navigate([navigationString[0]], {
        queryParams: {
          status: status[1],
        },
      });
    } else {
      this.router.navigate([navigationString[0]]);
    }
  }

  private getOrganizationActiveSubscriptionsAndRedirectIfNeeded(): Observable<SubscriptionResponse> {
    const subscriptionFilters: SubscriptionFilters = {
      operators: [],
      approaches: [],
      statuses: 'Actif',
      siret: '',
      accessModes: '',
      editors: '',
      editType:'',
      editBranchCode:'',
      editCompanyRegister:'',
      startSubmittedDate: '',
      endSubmittedDate: ''
    };

    const pagination: Pagination = {
      length: 0,
      pageSize: 1,
      pageIndex: 0
    }

    const sorting: Sorting = {
      orderBy: '',
      ascending: false
    }

    const params: HttpParams =  new UrlFormatterService().format(
      pagination,
      subscriptionFilters,
      sorting
    );

    return this.subscriptionHttpService
      .getSubscriptions(params);
  }
}
